//GOAL: Handle data and validation rules from FlexiItemContent inputs.


function FlexiItemChangeHandler({localstate, UpdateState, element, event}){
	console.log(element.validation);
	console.log(event);
	var oldvalue = localstate.itemdata[element.dbfield];
	//Controller expects event, but datetime only sends new value.
	if (element.rendertype==="kvinputdatetime"){
		console.log(event);
		//var date = event;
		localstate.itemdata[element.dbfield] = event;
		localstate.pendingupdate = true;
	} else if (element.rendertype==="kvinputcheckbox"){
		if (event.target.checked){
			localstate.itemdata[element.dbfield] = 1;
		} else {
			localstate.itemdata[element.dbfield] = 0;
		}
		localstate.pendingupdate = true;
	} else {
		//Regular inputs have event type properties, datetimes do not. Not even event.key.
		var newvalue = event.target.value;
		if (event.key !== "Tab" &&
			event.key !== "ArrowDown" &&
			event.key !== "ArrowUp" &&
			event.key !== "ShiftLeft" &&
			event.key !== "ShiftRight"
		) {
			if (element.validation.type==="text"){

				localstate.itemdata[element.dbfield] = newvalue;
				localstate.pendingupdate = true;
			}

			if (element.validation.type==="select"){
				localstate.itemdata[element.dbfield] = newvalue;
				localstate.pendingupdate = true;
			}

			if (element.validation.type==="number"){
				//Add validation here if needed. Min/max and step seem to be OK on client side, not sure why I ever didn't set a min in the past to avoid negative numbers!
				localstate.itemdata[element.dbfield] = newvalue;
				localstate.pendingupdate = true;
			}

			if (element.validation.type==="boolean"){
				//Add validation here if needed. Min/max and step seem to be OK on client side, not sure why I ever didn't set a min in the past to avoid negative numbers!
				localstate.itemdata[element.dbfield] = newvalue;
				localstate.pendingupdate = true;
			}

			if (element.postChangeHander){
				element.postChangeHander({localstate});
			}
		}
	}
	
	
	//Final validation is where we check if the record went back to its original values, we can un-set pendingupdate (unset save button).
	//To DO.
	UpdateState(localstate);

}

export default FlexiItemChangeHandler;